import type { FitViewOptions, Rect, XYPosition } from '@xyflow/react';

import { useInitialFit } from './useInitialFit';
import { useViewportOnResize } from './useViewportOnResize';

interface ChartViewportSyncProps {
  nodes: ReadonlyArray<{ position: XYPosition }>;
  nodeSize: { width: number; height: number };
  padding?: FitViewOptions['padding'];
  minZoom: number;
  contentBounds?: Rect;
}

const ChartViewportSync = ({
  nodes,
  nodeSize,
  padding,
  minZoom,
  contentBounds,
}: ChartViewportSyncProps) => {
  useInitialFit({ nodes, nodeSize, padding, minZoom, contentBounds });
  useViewportOnResize();
  return null;
};

export { ChartViewportSync };
